import styled, { css } from 'styled-components'
import check from '../../../../assets/addStockModal/pages/check.svg'
import cross from '../../../../assets/addStockModal/pages/cross.svg'

export const Container = styled.div`
  position: absolute;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 1vw;
  z-index: 1;
  max-height: 90vh;
  overflow-y: auto;
`

export const HeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 62vw;
  margin-top: 2.8vh;
  margin-left: 1.5vw;
  margin-right: 1vw;
`

export const HeaderText = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 1.4vw;
  font-weight: 700;
  margin-top: 0;
  margin-bottom: 0;
`

export const CloseDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2vw;
  cursor: pointer;
  width: 2.5vw;
  height: 2.5vw;

  :hover {
    background-color: #f4f4f4;
  }
`

export const CloseImg = styled.img`
  width: 0.8vw;
`

export const ProgressBarDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2.8vh;
  margin-left: 0.1vw;
  margin-right: 0.1vw;

  .active {
    background-color: #0090d3;
  }
`

export const ProgressBarCircle = styled.div`
  width: 1vw;
  height: 1vw;
  border-radius: 2vw;
  background-color: #c4c4c4;
`

export const ProgressBarLine = styled.div`
  width: 29vw;
  height: 0.5vh;
  background-color: #c4c4c4;
`

export const Phrase = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  margin-left: 0.7vw;
  line-height: 18.46px;
  color: #777777;
  padding: 0px 10px 0px 10px;
`

export const SwitchesDiv = styled.div`
  display: flex;
  margin-top: 3vh;
  align-items: center;
  justify-content: space-between;
  margin-left: 1.5vw;
  margin-right: 4vw;
`

export const SwitchDiv = styled.div`
  display: flex;
  flex-direction: column;
`

export const SwitchLabel = styled.label`
  font-weight: 700;
  font-size: 0.9vw;
  font-family: 'Inter', sans-serif;
`

export const SwitchBox = styled.label`
  display: inline-block;
  position: relative;
  margin-top: 1vh;
  width: 60px;
  height: 34px;
`

export const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  :checked + .slider {
    background-color: #2196f3;
    border: 0;
    padding: 2px;
  }

  :focus + .slider {
    box-shadow: 0 0 1px #2196f3;
  }

  :checked + .slider:before {
    background-image: url(${check});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 15px 15px;
    background-color: #fff;
    -webkit-transform: translateX(24px);
    -ms-transform: translateX(24px);
    transform: translateX(24px);
  }
`

export const SwitchSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;
  border: #696969 2px solid;

  :before {
    display: block;
    position: relative;
    content: '';
    height: 24px;
    width: 24px;
    left: 5.5px;
    top: 2.8px;
    background-color: #696969;
    border-radius: 50%;
    transition: all 0.4s;
    background-image: url(${cross});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 11px 11px;
  }
`

export const MappingArea = styled.div`
  background-color: #fff;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  margin: 18px 15px 0px 15px;
  width: 53rem;

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    cursor: pointer;
  }

  ::-webkit-scrollbar-thumb {
    background: #ffffff; 
    border-radius: 3px; 
  }

  ::-webkit-scrollbar-track {
    background: #e1e1e1; 
    border-radius: 3px; 
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }
`

export const RowsDiv = styled.div`
  display: inline-block;
  min-width: 100%;
  padding-left: 0.2vw;
  padding-top: 1vh;
  padding-bottom: 1vh;
  border: 2px solid #f4f4f4;
  border-radius: 1vw;
`

export const RowDiv = styled.div`
  display: flex;
  height: 6vh;
  padding-top: 0.5vh;
  padding-bottom: 0.5vh;
  align-items: center;
`

export const RowText = styled.p`
  position: relative;
  bottom: 0.4vh;
  font-size: 0.9vw;
  font-family: 'Inter', sans-serif;
  color: #777777;
  width: 5vw;
  margin-left: 1vw;
  margin-right: 3vw;
  margin-top: 0;
  margin-bottom: 0;
`

export const RowFieldDiv = styled.div`
  display: flex;
  align-items: center;
`

export const PreviewText = styled.h3`
  font-family: 'Inter', sans-serif;
  font-size: 1.2vw;
  margin-top: 3vh;
  margin-bottom: vh;
  margin-left: 0.5vw;
  margin-right: 0;
`

export const Preview = styled.table`
  color: #696969;
  border-collapse: collapse;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  margin-top: 1.5vh;
  background-color: #ffffff;
  width: 100%;

  tr:nth-child(2) td:first-child {
    border-top-left-radius: 0.8vw;
  }

  tr:nth-child(2) td:last-child {
    border-top-right-radius: 0.8vw;
  }

  tr:last-child td:first-child {
    border-bottom-left-radius: 0.8vw;
  }

  tr:last-child td:last-child {
    border-bottom-right-radius: 0.8vw;
  }
`

export const TableBody = styled.tbody`
  display: flex;
  flex-direction: column;
`

export const HeaderRow = styled.tr`
  display: flex;
`

export const HeaderCell = styled.th`
  display: flex;
  background-color: #fff;
  width: 125.2px;
  padding: 10px 10px 10px 20px;
`

export const ItemRow = styled.tr`
  display: flex;
`

export const ItemCell = styled.td`
  background-color: #f4f4f4;
  width: 125.2px;
  padding: 10px 10px 10px 20px;
`

export const ButtonsDiv = styled.div`
  display: flex;
  margin-top: 3vh;
  align-items: center;
  margin-left: 39vw;
`

export const CancelButton = styled.button`
  width: 8vw;
  height: 5.8vh;
  background-color: #fff;
  color: #0090d3;
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  border: 0;
  cursor: pointer;
`

export const PreviousButtonDiv = styled.div`
  display: flex;
  align-items: center;
  width: 6.5vw;
  height: 5.8vh;
  background-color: #fff;
  color: #0090d3;
  border: solid #0090d3 1px;
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  margin-left: 1vw;
  border-radius: 3vw;
  cursor: pointer;
`

export const PreviousButtonImage = styled.img`
  margin-left: 1vw;
  width: 0.9vw;
`

export const PreviousButtonText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
  margin-left: 0.6vw;
`

export const NextButtonDiv = styled.div`
  display: flex;
  align-items: center;
  width: 8vw;
  height: 5.8vh;
  background-color: #0090d3;
  color: #fff;
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  margin-left: 1vw;
  border-radius: 3vw;
  cursor: pointer;
`

export const NextButtonImage = styled.img`
  margin-left: 1vw;
  width: 0.9vw;
`

export const NextButtonText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
  margin-left: 0.6vw;
`

export const DisabledNextButtonDiv = styled.div`
  display: flex;
  align-items: center;
  width: 8vw;
  height: 5.8vh;
  background-color: #ebebeb;
  color: #c4c4c4;
  margin-top: 2.5vh;
  margin-bottom: 2.5vh;
  margin-left: 1vw;
  border-radius: 3vw;
  cursor: not-allowed;
`

export const DisabledNextButtonImage = styled.img`
  margin-left: 1vw;
  width: 0.9vw;
`

export const DisabledNextButtonText = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 1vw;
  font-weight: 700;
  margin-left: 0.6vw;
`

export const MappingSectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
`

export const MappingSection = styled.div`
  border: 2px solid #f4f4f4;
  border-radius: 10px;
  padding: 15px;
  overflow-x: auto;
  white-space: nowrap;
`

export const MappingSectionTitle = styled.h3`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #333;
  margin: 0 0 15px 0;
  display: flex;
  align-items: center;
  gap: 8px;

  &.matched {
    color: #22c55e;
  }

  &.unmatched-spreadsheet {
    color: #f59e0b;
  }

  &.unmatched-stock {
    color: #3b82f6;
  }
`

export const MappingSectionCount = styled.span`
  font-size: 12px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 10px;
  background-color: #f4f4f4;
  color: #777;
`

export const MappingSectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const MappingRowsContainer = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 0;
`

export const MappingColumnItem = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 150px;
`

export const MappingSelect = styled.select`
  background-color: #ebebeb;
  color: #777777;
  height: 5.3vh;
  width: 9vw;
  padding-left: 1vw;
  padding-right: 2.4vw;
  border-radius: 2vw;
  border: 1px solid #e1e1e1;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23777777' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position-x: 7vw;
  background-position-y: 1.6vh;
  background-size: 18px 15px;
  margin: 0 8px 5px 8px;
  font-family: 'Inter', sans-serif;
  font-size: 12px;

  &:focus {
    outline: none;
  }
`

export const MappingRowLabel = styled.p`
  font-size: 0.9vw;
  font-family: 'Inter', sans-serif;
  color: #777777;
  margin: 0;
  padding: 8px 0;
`

export const EmptyMessage = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  color: #999;
  font-style: italic;
  margin: 0;
  padding: 10px 0;
`